/**
 * Project : workspace
 * File    : LandingFooterPage.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.homepage

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Divider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import component.button.SecondaryButton
import navigation.AppNavigator
import navigation.route.policy.PolicyNavRoute
import theme.ThemeColor

@Composable
        /**
         * Executes the landing footer page operation.
         *
         * @receiver TODO
         * @return Unit – no return value.
         */
fun LandingFooterPage() {
    Column(
        modifier = Modifier.fillMaxWidth()
            .background(ThemeColor.shared().PrimaryColor),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        // Logo & Description
//        Row(
//            verticalAlignment = Alignment.CenterVertically,
//            horizontalArrangement = Arrangement.Center,
//            modifier = Modifier.fillMaxWidth().padding(16.dp)
//        ) {
//            Box(
//                modifier = Modifier
//                    .wrapContentHeight()
//                    .wrapContentWidth()
//                    .padding(bottom = 8.dp)
//
//            ) {
//                Image(
//                    modifier = Modifier.height(100.dp).width(100.dp)
//                        .padding(start = 0.dp, end = 0.dp, top = 0.dp),
//                    painter = painterResource(Res.drawable.business_logo_web),
//                    contentDescription = null
//                )
//            }
//            Spacer(modifier = Modifier.width(12.dp))
//            Text(
//                text = AppConfig.shared().appName,
//                style = MaterialTheme.typography.titleMedium,
//                color = Color.White
//            )
//        }

        // Links
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.Center,
        ) {
            Column(
                verticalArrangement = Arrangement.spacedBy(8.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.fillMaxSize().weight(0.6f)
            ) {
                Text("Address", color = ThemeColor.shared().White, fontSize = 14.sp)
                Text(
                    "Near Gayatri Mandir, Muhalla New Area, " +
                            "Sasaram, Rohtas",
                    color = ThemeColor.shared().White,
                    fontSize = 12.sp
                )
                Text("Bihar, 821115", color = ThemeColor.shared().White, fontSize = 12.sp)
            }
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.fillMaxSize().weight(0.4f)
            ) {
                SecondaryButton("Privacy Policy", onClick = {
                    AuthViewModel().hideAuthContainer()
                    AppNavigator.shared().navigate(PolicyNavRoute.HOME)
                })
            }
        }

        Divider(color = ThemeColor.shared().TextColor.copy(alpha = 0.3f), thickness = 1.dp)

        // Bottom note
        Text(
            text = "© 2025 Mandee.AI. All rights reserved.",
            color = ThemeColor.shared().White,
            fontSize = 12.sp,
            modifier = Modifier.align(Alignment.CenterHorizontally)
        )
    }
}